import {context} from "../constants/context";
import sessionStorage from './storage/session_storage';
import localStorage from './storage/local_storage';

import {PusherFactory} from "./pusher_factory";

class PusherConnection {

    constructor(company) {
        this.promise = new Promise((resolve, reject) => {
            if(!company.$has('pusher')) {
                reject();
                return;
            }
            return company.$get('pusher').then((pusherConfig) => {
                const pusher = PusherFactory.create({
                    cluster: pusherConfig.cluster,
                    encrypted: true,
                    authEndpoint: company.$link('pusher').href,
                    auth: {
                        headers: {
                            'App-Id': context.appId,
                            'App-Key': context.appKey,
                            'Auth-Token': localStorage.getItem('auth_token')
                        }
                    }
                }, pusherConfig.key);
                resolve(pusher);
            }, reject);
        });
    }

    subscribe(channelName) {
        return new Promise((resolve, reject) => {
            this.promise.then((pusher) => {
                if (!pusher){
                    reject();
                    return;
                }
                resolve(pusher.subscribe(channelName));
            }, reject);
        });
    }

    unsubscribe(channelName) {
        return new Promise((resolve, reject) => {
            this.promise.then((pusher) => {
                if (!pusher){
                    reject();
                    return;
                }
                resolve(pusher.unsubscribe(channelName));
            }, reject);
        });
    }

}

export {
    PusherConnection
}
